import type { AxiosInstance } from 'axios';
import { govApiLog } from '@gov-nx/core/app';
import type { OsobyFotoDto, OsobyFyzickaOsobaDto } from '../generated';

export const robPersonQuery = async (
	axiosInstance: AxiosInstance
): Promise<OsobyFyzickaOsobaDto> => {
	govApiLog('/api/v1/fyzickeosoby');
	const { data } = await axiosInstance.get('/api/v1/fyzickeosoby');
	return data;
};

export const robPersonPhotoQuery = async (
	axiosInstance: AxiosInstance
): Promise<OsobyFotoDto> => {
	govApiLog('/api/v1/fyzickeosoby/foto');
	const { data } = await axiosInstance.get('/api/v1/fyzickeosoby/foto');
	return data;
};
